<template>
    <el-dialog title="Send Mail"
               closeable
               :visible.sync="value"
               :close-on-click-modal="false"
               :close-on-press-escape="false"
               @close="$emit('input', false)"
               width="50%"
    >
        <el-form size="medium" label-width="120px">
            <el-form-item label="Subject">
                <el-input v-model="options.subject" class="w500" placeholder="Subject" clearable/>
            </el-form-item>
            <el-form-item label="Mail Template">
                <el-select v-model="options.mail_template_id" placeholder="Select template">
                    <el-option
                        v-for="item in templateList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="Mail From">
                <el-select v-model="options.mail_account_id" placeholder="Select mail">
                    <el-option
                        v-for="item in configList"
                        :key="item.id"
                        :label="item.from_name"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="CC">
                <el-input v-model="options.cc" class="w500" placeholder="CC" clearable/>
            </el-form-item>
            <el-form-item label="BCC">
                <el-input v-model="options.bcc" class="w500" placeholder="BCC" clearable/>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" @click="onSend">Send</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<script>
import ApiService from "../utils/ApiService";

export default {
    name: "DialogSendMail",
    props: {
        value: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            templateList: [],
            configList: [],
            options: {
                mail_template_id: null,
                mail_account_id: null,
                subject: null,
                cc: null,
                bcc: null,
            }
        }
    },
    watch: {
        value(newValue) {
            if (newValue) {
                this.fetchTemplateList();
                this.fetchConfigList();
            }
        }
    },
    methods: {
        fetchTemplateList() {
            ApiService.get('/buildium/mail-templates').then(response => {
                this.templateList = response.data.items;
            }).catch(reason => {
                this.$message.error(reason.message);
            });
        },
        fetchConfigList() {
            ApiService.get('/buildium/mail-configs').then(response => {
                this.configList = response.data.items;
            }).catch(reason => {
                this.$message.error(reason.message);
            });
        },
        onSend() {
            const options = this.options;
            if (!options.subject) {
                this.$message.error('Subject is required');
                return;
            }

            if (!options.mail_template_id) {
                this.$message.error('Mail template is required');
                return;
            }

            if (!options.mail_account_id) {
                this.$message.error('Mail account is required');
                return;
            }
            this.$emit('send', this.options);
        }
    },
    mounted() {

    }
}
</script>

<style scoped>

</style>